import React from 'react'

function ListingRentComp() {
    return (
        <section id="listing-rent-comp">
            <div className='container my-5'>
                <div className='row' >
                    <h1 className='text-primary fw-bold text-start'>Our Listing</h1>
                    <div id='the-residences-at-greenbelt' className='row p-3 shadow mb-5'>
                        <div className='col-lg-8'>
                            <div id="TheResidencesAtGreenbeltUnit" className="carousel slide" data-bs-ride="carousel">
                                <div className="carousel-indicators">
                                    <button type="button" data-bs-target="#TheResidencesAtGreenbeltUnit" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                                    <button type="button" data-bs-target="#TheResidencesAtGreenbeltUnit" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                    <button type="button" data-bs-target="#TheResidencesAtGreenbeltUnit" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                    <button type="button" data-bs-target="#TheResidencesAtGreenbeltUnit" data-bs-slide-to="3" aria-label="Slide 4"></button>
                                    <button type="button" data-bs-target="#TheResidencesAtGreenbeltUnit" data-bs-slide-to="4" aria-label="Slide 5"></button>
                                    <button type="button" data-bs-target="#TheResidencesAtGreenbeltUnit" data-bs-slide-to="5" aria-label="Slide 6"></button>
                                    <button type="button" data-bs-target="#TheResidencesAtGreenbeltUnit" data-bs-slide-to="6" aria-label="Slide 7"></button>
                                    <button type="button" data-bs-target="#TheResidencesAtGreenbeltUnit" data-bs-slide-to="7" aria-label="Slide 8"></button>
                                </div>
                                <div className='pt-5'>
                                    <div className="carousel-inner">
                                        <div className="carousel-item active">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/TheResidencesAtGreenbel/1+-+living.JPG"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Living Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/TheResidencesAtGreenbel/2-+living.JPG"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Living and TV</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/TheResidencesAtGreenbel/7+-+dining.JPG"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Dining</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/TheResidencesAtGreenbel/9+-+dining%2C+foyer.JPG"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Dinning and Foyer</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/TheResidencesAtGreenbel/10+-+foyer.JPG"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Foyer</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/TheResidencesAtGreenbel/14+-+kitchen.JPG"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Kitchen Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/TheResidencesAtGreenbel/22+-+Bedroom.jpg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Bedroom</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <button className="carousel-control-prev" type="button" data-bs-target="#TheResidencesAtGreenbeltUnit" data-bs-slide="prev">
                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Previous</span>
                                </button>
                                <button className="carousel-control-next" type="button" data-bs-target="#TheResidencesAtGreenbeltUnit" data-bs-slide="next">
                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Next</span>
                                </button>
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <h4 className='text-primary text-start'>Furnished 1 Bedroom with Parking Slot at The Residences at Greenbelt, Makati</h4>
                            <p className='text-start'> <small><i class="bi bi-pin-map-fill"></i> San Lorenzo, Makati</small></p>

                            <div className='text-start'>
                                <p>
                                    <b>The Residences At Greenbelt (TRAG)</b>
                                    <br />
                                    Unit 24-J
                                </p>
                                <b>Description:</b>
                                <ul>
                                    <li>1 Bedroom</li>
                                    <li>Fully-furnished</li>
                                    <li>70 sq.m. (753.20 sq.ft)</li>
                                    <li>1 Parking Slot</li>
                                    <li>Interior Designed</li>
                                </ul>

                                <b>Unit Features:</b>
                                <ul>
                                    <li>has LCD TV</li>
                                    <li>has a Refrigerator</li>
                                    <li>has Electric Range</li>
                                    <li>has Microwave</li>
                                    <li>has Washing Machine and Dryer</li>
                                </ul>
                                <p>
                                    <small>
                                        Available in October 2022
                                        <br />
                                        PhP82,000 per month
                                        <br />
                                        Minimum 12 months lease
                                    </small>
                                </p>
                                <div className='d-flex flex-row'>
                                    <a className='btn btn-primary' href='/listing-rent/the-residences-at-greenbelt'>View More Details</a>
                                    <a className='btn btn-success mx-3' href='/contact-us'>Contact us</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id='st-francis-shangrila' className='row p-3 shadow mb-5'>
                        <div className='col-lg-8'>
                            <div id="StFrancisShangrilaUnit" className="carousel slide" data-bs-ride="carousel">
                                <div className="carousel-indicators">
                                    <button type="button" data-bs-target="#StFrancisShangrilaUnit" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                                    <button type="button" data-bs-target="#StFrancisShangrilaUnit" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                    <button type="button" data-bs-target="#StFrancisShangrilaUnit" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                    <button type="button" data-bs-target="#StFrancisShangrilaUnit" data-bs-slide-to="3" aria-label="Slide 4"></button>
                                    <button type="button" data-bs-target="#StFrancisShangrilaUnit" data-bs-slide-to="4" aria-label="Slide 5"></button>
                                    <button type="button" data-bs-target="#StFrancisShangrilaUnit" data-bs-slide-to="5" aria-label="Slide 6"></button>
                                    <button type="button" data-bs-target="#StFrancisShangrilaUnit" data-bs-slide-to="6" aria-label="Slide 7"></button>
                                    <button type="button" data-bs-target="#StFrancisShangrilaUnit" data-bs-slide-to="7" aria-label="Slide 8"></button>
                                    <button type="button" data-bs-target="#StFrancisShangrilaUnit" data-bs-slide-to="8" aria-label="Slide 9"></button>
                                    <button type="button" data-bs-target="#StFrancisShangrilaUnit" data-bs-slide-to="9" aria-label="Slide 10"></button>
                                    <button type="button" data-bs-target="#StFrancisShangrilaUnit" data-bs-slide-to="10" aria-label="Slide 11"></button>
                                    <button type="button" data-bs-target="#StFrancisShangrilaUnit" data-bs-slide-to="11" aria-label="Slide 12"></button>

                                </div>
                                <div className='pt-5'>
                                    <div className="carousel-inner">
                                        <div className="carousel-item active">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis12.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Bedroom</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis11.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Living Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis10.jpeg"
                                                className="img-fluid " alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Dining and Kitchen</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis9.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Lobby Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis8.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Lounge</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis77.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Grand View</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis6.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Sauna</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis5.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Gym</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis4.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Gym</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis3.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Videoke Room</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis2.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Jacuzzi Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/StFrancisSharila/StFrancis1.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Hallway</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <button className="carousel-control-prev" type="button" data-bs-target="#StFrancisShangrilaUnit" data-bs-slide="prev">
                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Previous</span>
                                </button>
                                <button className="carousel-control-next" type="button" data-bs-target="#StFrancisShangrilaUnit" data-bs-slide="next">
                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Next</span>
                                </button>
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <h4 className='text-primary text-start'>Furnished 1 Bedroom in St. Francis Shangri-La, Mandaluyong</h4>
                            <p className='text-start'> <small>
                                <i class="bi bi-pin-map-fill">
                                </i> Shaw Boulevard cor St. Francis, Ortigas Center, Mandaluyong
                            </small>
                            </p>

                            <div className='text-start'>
                                <p>
                                    <b>The St Frances Shangri-La</b>
                                    <br />
                                    Unit: TBP
                                </p>
                                <b>Description:</b>
                                <ul>
                                    <li>1 Bedroom</li>
                                    <li>Fully-furnished</li>
                                    <li>57 sq.m. (613.54 sq.ft)</li>
                                    <li>Panoramic views</li>
                                    <li>near Shopping Malls</li>
                                </ul>

                                <b>Unit Features:</b>
                                <ul>
                                    <li>luxerous Wooden BedFrame</li>
                                    <li>elegant Wooden Cabinets</li>
                                    <li>ostentatious Dining Area</li>
                                    <li>classy Lobby</li>
                                    <li>grand View of Ortigas Center</li>
                                </ul>
                                <p>
                                    <small>
                                        Available for viewing
                                        <br />
                                        PhP80,000 per month
                                        <br />
                                        Minimum 12 months lease
                                    </small>
                                </p>
                                <div className='d-flex flex-row'>
                                    <a className='btn btn-primary' href='/listing-rent/st-francis-shangrila'>View More Details</a>
                                    <a className='btn btn-success mx-3' href='/contact-us'>Contact us</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id='the-lerato' className='row p-3 shadow mb-5'>
                        <div className='col-lg-8'>
                            <div id="LeratoUnit" className="carousel slide" data-bs-ride="carousel">
                                <div className="carousel-indicators">
                                    <button type="button" data-bs-target="#LeratoUnit" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                                    <button type="button" data-bs-target="#LeratoUnit" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                    <button type="button" data-bs-target="#LeratoUnit" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                </div>
                                <div className='pt-5'>
                                    <div className="carousel-inner">
                                        <div className="carousel-item active">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/Lerato/Lerato1.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Bedroom Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/Lerato/Lerato2.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Living and Kitchen Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/Lerato/Lerato3.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Toilet and Bath</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <button className="carousel-control-prev" type="button" data-bs-target="#LeratoUnit" data-bs-slide="prev">
                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Previous</span>
                                </button>
                                <button className="carousel-control-next" type="button" data-bs-target="#LeratoUnit" data-bs-slide="next">
                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Next</span>
                                </button>
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <h4 className='text-primary text-start'>Japanese Syle Furnished Studio in Lerato, Makati</h4>
                            <p className='text-start'> <small><i class="bi bi-pin-map-fill"></i> Malugay cor Ayala Avenue, Makati</small></p>

                            <div className='text-start'>
                                <p>
                                    <b>The Lerato</b>
                                    <br />
                                    Unit: TBP
                                </p>
                                <b>Description:</b>
                                <ul>
                                    <li>1 Studio Unit</li>
                                    <li>Japanese Style furnished</li>
                                    <li>32 sq.m. (344 sq.ft)</li>
                                    <li>1 Toilet and Bath</li>
                                    <li>Big amenities</li>
                                </ul>

                                <b>Unit Features:</b>
                                <ul>
                                    <li>has Shower Heater</li>
                                    <li>has a Refrigerator</li>
                                    <li>has Electric Range</li>
                                    <li>has Microwave</li>
                                    <li>has Washing Machine and Dryer</li>
                                </ul>
                                <p>
                                    <small>
                                        Available for Viewing
                                        <br />
                                        PhP35,000 per month
                                        <br />
                                        Minimum 12 months lease
                                    </small>
                                </p>
                                <div className='d-flex flex-row'>
                                    <a className='btn btn-primary' href='/listing-rent/the-lerato'>View More Details</a>
                                    <a className='btn btn-success mx-3' href='/contact-us'>Contact us</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id='easton-place' className='row p-3 shadow mb-5'>
                        <div className='col-lg-8'>
                            <div id="EastonPlaceUnit" className="carousel slide" data-bs-ride="carousel">
                                <div className="carousel-indicators">
                                    <button type="button" data-bs-target="#EastonPlaceUnit" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                                    <button type="button" data-bs-target="#EastonPlaceUnit" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                    <button type="button" data-bs-target="#EastonPlaceUnit" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                    <button type="button" data-bs-target="#EastonPlaceUnit" data-bs-slide-to="3" aria-label="Slide 4"></button>
                                    <button type="button" data-bs-target="#EastonPlaceUnit" data-bs-slide-to="4" aria-label="Slide 5"></button>
                                    <button type="button" data-bs-target="#EastonPlaceUnit" data-bs-slide-to="5" aria-label="Slide 6"></button>
                                    <button type="button" data-bs-target="#EastonPlaceUnit" data-bs-slide-to="6" aria-label="Slide 7"></button>
                                    <button type="button" data-bs-target="#EastonPlaceUnit" data-bs-slide-to="7" aria-label="Slide 8"></button>
                                    <button type="button" data-bs-target="#EastonPlaceUnit" data-bs-slide-to="8" aria-label="Slide 9"></button>
                                    <button type="button" data-bs-target="#EastonPlaceUnit" data-bs-slide-to="9" aria-label="Slide 10"></button>
                                </div>
                                <div className='pt-5'>
                                    <div className="carousel-inner">
                                        <div className="carousel-item active">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/EastonPlace/EastonPlace1.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Living Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/EastonPlace/EastonPlace2.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Living and Foyer Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/EastonPlace/EastonPlace3.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Living and Dining</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/EastonPlace/EastonPlace4.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Dining Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/EastonPlace/EastonPlace5.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Kitchen Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/EastonPlace/EastonPlace6.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Toilet and Bath</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/EastonPlace/EastonPlace7.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Bedroom Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/EastonPlace/EastonPlace8.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Bedroom Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/EastonPlace/EastonPlace9.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Maid's Room</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/EastonPlace/EastonPlace10.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Toilet and Bath</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <button className="carousel-control-prev" type="button" data-bs-target="#EastonPlaceUnit" data-bs-slide="prev">
                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Previous</span>
                                </button>
                                <button className="carousel-control-next" type="button" data-bs-target="#EastonPlaceUnit" data-bs-slide="next">
                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Next</span>
                                </button>
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <h4 className='text-primary text-start'>2 Bedroom Corner Unit in Easton Place, Makati</h4>
                            <p className='text-start'> <small><i class="bi bi-pin-map-fill"></i> Valero Cor Rufino Street, Salcedo Village, Makati</small></p>

                            <div className='text-start'>
                                <p>
                                    <b>Easton Place</b>
                                    <br />
                                    Unit: TBP
                                </p>
                                <b>Description:</b>
                                <ul>
                                    <li>2 Bedroom Unit</li>
                                    <li>Fully Furnished</li>
                                    <li>131 sq.m.(1409.56 sq.ft.)</li>
                                    <li>2 Toilet and Bath</li>
                                    <li>1 parking space included</li>
                                    <li>Corner unit on mid-high floor</li>
                                </ul>

                                <b>Unit Features:</b>
                                <ul>
                                    <li>has nice views</li>
                                    <li>Floor-to-ceiling windows</li>
                                    <li>2 spacious balconies</li>
                                    <li>Maid's room with T&B</li>
                                    <li>Laundry room with Washing Machine</li>
                                </ul>
                                <p>
                                    <small>
                                        Available for Viewing
                                        <br />
                                        PhP80,000 per month
                                        <br />
                                        Minimum 12 months lease
                                    </small>
                                </p>
                                <div className='d-flex flex-row'>
                                    <a className='btn btn-primary' href='/listing-rent/easton-place'>View More Details</a>
                                    <a className='btn btn-success mx-3' href='/contact-us'>Contact us</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id='asia-tower' className='row p-3 shadow mb-5'>
                        <div className='col-lg-8'>
                            <div id="AsiaTowerUnit" className="carousel slide" data-bs-ride="carousel">
                                <div className="carousel-indicators">
                                    <button type="button" data-bs-target="#AsiaTowerUnit" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                                    <button type="button" data-bs-target="#AsiaTowerUnit" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                    <button type="button" data-bs-target="#AsiaTowerUnit" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                    <button type="button" data-bs-target="#AsiaTowerUnit" data-bs-slide-to="3" aria-label="Slide 4"></button>
                                    <button type="button" data-bs-target="#AsiaTowerUnit" data-bs-slide-to="4" aria-label="Slide 5"></button>
                                    <button type="button" data-bs-target="#AsiaTowerUnit" data-bs-slide-to="5" aria-label="Slide 6"></button>
                                    <button type="button" data-bs-target="#AsiaTowerUnit" data-bs-slide-to="6" aria-label="Slide 7"></button>
                                    <button type="button" data-bs-target="#AsiaTowerUnit" data-bs-slide-to="7" aria-label="Slide 8"></button>
                                    <button type="button" data-bs-target="#AsiaTowerUnit" data-bs-slide-to="8" aria-label="Slide 9"></button>
                                </div>
                                <div className='pt-5'>
                                    <div className="carousel-inner">
                                        <div className="carousel-item active">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/AsiaTower/AsiaTower1.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Living Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/AsiaTower/AsiaTower2.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Living Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/AsiaTower/AsiaTower3.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Dining Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/AsiaTower/AsiaTower4.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Foyer Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/AsiaTower/AsiaTower5.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Kitchen Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/AsiaTower/AsiaTower6.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Kitchen Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/AsiaTower/AsiaTower7.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Bedroom Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/AsiaTower/AsiaTower8.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Bedroom Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/AsiaTower/AsiaTower10.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Bedroom Area</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <button className="carousel-control-prev" type="button" data-bs-target="#AsiaTowerUnit" data-bs-slide="prev">
                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Previous</span>
                                </button>
                                <button className="carousel-control-next" type="button" data-bs-target="#AsiaTowerUnit" data-bs-slide="next">
                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Next</span>
                                </button>
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <h4 className='text-primary text-start'>2 Bedroom Corner Unit in Asia Tower, Makati</h4>
                            <p className='text-start'> <small><i class="bi bi-pin-map-fill"></i> Paseo de Roxas, Legazpi Village, Makati</small></p>

                            <div className='text-start'>
                                <p>
                                    <b>Asia Tower</b>
                                    <br />
                                    Unit: TBP
                                </p>
                                <b>Description:</b>
                                <ul>
                                    <li>2 Bedroom Unit</li>
                                    <li>Fully Furnished</li>
                                    <li>77 sq.m(828.821 sq.ft)</li>
                                    <li>2 Toilet and Bath</li>
                                    <li>Corner unit</li>
                                    <li>Parking available at additional cost</li>
                                </ul>

                                <b>Unit Features:</b>
                                <ul>
                                    <li>has leather sofa</li>
                                    <li>all wooden furnitures</li>
                                    <li>has Refrigator</li>
                                    <li>has Microwave</li>
                                    <li>has gas burner</li>
                                </ul>
                                <p>
                                    <small>
                                        Available for Viewing
                                        <br />
                                        PhP55,000 per month
                                        <br />
                                        Minimum 12 months lease
                                    </small>
                                </p>
                                <div className='d-flex flex-row'>
                                    <a className='btn btn-primary' href='/listing-rent/asia-tower'>View More Details</a>
                                    <a className='btn btn-success mx-3' href='/contact-us'>Contact us</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id='kl-mosaic-tower' className='row p-3 shadow mb-5'>
                        <div className='col-lg-8'>
                            <div id="KLMosaicTowerUnit" className="carousel slide" data-bs-ride="carousel">
                                <div className="carousel-indicators">
                                    <button type="button" data-bs-target="#KLMosaicTowerUnit" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                                    <button type="button" data-bs-target="#KLMosaicTowerUnit" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                    <button type="button" data-bs-target="#KLMosaicTowerUnit" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                    <button type="button" data-bs-target="#KLMosaicTowerUnit" data-bs-slide-to="3" aria-label="Slide 4"></button>
                                    <button type="button" data-bs-target="#KLMosaicTowerUnit" data-bs-slide-to="4" aria-label="Slide 5"></button>
                                    <button type="button" data-bs-target="#KLMosaicTowerUnit" data-bs-slide-to="5" aria-label="Slide 6"></button>
                                    <button type="button" data-bs-target="#KLMosaicTowerUnit" data-bs-slide-to="6" aria-label="Slide 7"></button>
                                    <button type="button" data-bs-target="#KLMosaicTowerUnit" data-bs-slide-to="7" aria-label="Slide 8"></button>
                                    <button type="button" data-bs-target="#KLMosaicTowerUnit" data-bs-slide-to="8" aria-label="Slide 9"></button>
                                </div>
                                <div className='pt-5'>
                                    <div className="carousel-inner">
                                        <div className="carousel-item active">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/KLMosaicTower/KLMosaicTower1.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Living and Bed Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/KLMosaicTower/KLMosaicTower2.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Living Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/KLMosaicTower/KLMosaicTower3.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Living and Bed Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/KLMosaicTower/KLMosaicTower4.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Living and Bed Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/KLMosaicTower/KLMosaicTower5.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Small Dining and Study Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/KLMosaicTower/KLMosaicTower6.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Bed Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/KLMosaicTower/KLMosaicTower7.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Bed Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/KLMosaicTower/KLMosaicTower8.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Kitchen Area</h4>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/KLMosaicTower/KLMosaicTower9.jpeg"
                                                className="img-fluid" alt="..."></img>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4>Kitchen Area</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <button className="carousel-control-prev" type="button" data-bs-target="#KLMosaicTowerUnit" data-bs-slide="prev">
                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Previous</span>
                                </button>
                                <button className="carousel-control-next" type="button" data-bs-target="#KLMosaicTowerUnit" data-bs-slide="next">
                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Next</span>
                                </button>
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <h4 className='text-primary text-start'>1 Studio in KL Mosaic Tower, Makati</h4>
                            <p className='text-start'> <small><i class="bi bi-pin-map-fill"></i> Aguirre, Legazpi Village, Makati</small></p>

                            <div className='text-start'>
                                <p>
                                    <b>KL Mosaic Tower</b>
                                    <br />
                                    Unit: TBP
                                </p>
                                <b>Description:</b>
                                <ul>
                                    <li>1 Studio Unit</li>
                                    <li>Fully Furnished</li>
                                    <li>36 sq.m(387.501 sq.ft)</li>
                                    <li>1 Toilet and Bath</li>
                                    <li>1 Block from Greenbelt 1</li>
                                    <li>Located behind Asian Institute of Management</li>
                                </ul>

                                <b>Unit Features:</b>
                                <ul>
                                    <li>has comfy sofa</li>
                                    <li>has LCD TV</li>
                                    <li>has small office area</li>
                                    <li>has Microwave</li>
                                    <li>has Refrigerator</li>
                                </ul>
                                <p>
                                    <small>
                                        Available for Viewing
                                        <br />
                                        PhP36,000 per month
                                        <br />
                                        Minimum 12 months lease
                                    </small>
                                </p>
                                <div className='d-flex flex-row'>
                                    <a className='btn btn-primary' href='/listing-rent/kl-mosaic-tower'>View More Details</a>
                                    <a className='btn btn-success mx-3' href='/contact-us'>Contact us</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </section>
    )
}

export default ListingRentComp